module.exports = "/fonts/fa-regular-400.svg?8fdea4e89ac405d9f8db327adb331d8d";